export default __webpack_public_path__ + "static/media/A1.808e5527.gif";